const PILLARS = [ ["dimension", "Dimensione", 1.5], ["marketing", "Marketing", 1.5],
  ["organization", "Organizzazione", 1], ["sector", "Settore", 1] ];

export const ScorePillars = ({ pillars, penalties = 0 }) => {
  if (!pillars || !Object.keys(pillars).length) return null;
  return <div className="score-pillars" data-testid="score-pillars">
    {PILLARS.map(([key, label, maximum]) => <div className="score-pillar" key={key} data-testid={`score-pillar-${key}`}>
      <span>{label}</span><strong>{(pillars[key] || 0).toLocaleString("it-IT", { maximumFractionDigits: 2 })} / {maximum.toLocaleString("it-IT")}</strong>
      <div className="score-pillar-track"><span style={{ width: `${Math.max(0, Math.min(100, (pillars[key] || 0) / maximum * 100))}%` }} /></div>
    </div>)}
    {penalties > 0 && <p className="score-penalties" data-testid="score-penalties">Penalità −{penalties.toLocaleString("it-IT", { maximumFractionDigits: 2 })}</p>}
  </div>;
};